module.exports = __webpack_public_path__ + "img/651.cd3a7cf4.png";